import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import classnames from "classnames";

import styles from "./high-frequency-word.module.css";
import * as highFrequencyWordActions from "../../redux/actions/highFrequencyWord";
import { srcPath } from "../../util/Path";
import { State } from "../../redux/store";
import { backToWeb } from "../../util/Util";
import { useImgLoaded } from "../../hooks/CustomHooks";

interface Props {
  scale: number;
  left: number;
}

const FinishBoard = (props: Props) => {
  const { scale, left } = props;
  const dispatch = useDispatch();
  const { grade, unit, webUrl } = useSelector((state: State) => state.shared);
  const [imgLoaded, addImgLoaded] = useImgLoaded(1);

  const style: React.CSSProperties = {
    width: window.innerWidth / scale,
    left: `${left}px`,
    display: imgLoaded ? "block" : "none",
  };

  return (
    <CSSTransition
      in={imgLoaded}
      timeout={150}
      classNames={{
        enter: styles.finishEnter,
        enterActive: styles.finishEnterActive,
      }}
    >
      <div className={styles.finishBoard} style={style}>
        <div className={styles.finishBoardContainer}>
          <img
            className={styles.finishText}
            src={srcPath("high-frequency-word/finish_text.png")}
            alt=""
            onLoad={addImgLoaded}
          />
          <div className={styles.finishBtnContainer}>
            <img
              className={classnames("btn", "main-btn")}
              src={srcPath("high-frequency-word/finish_back.png")}
              alt=""
              onLoad={addImgLoaded}
              onClick={() => backToWeb("small_book", webUrl, grade, unit)}
            />
            <img
              className={classnames("btn", "main-btn")}
              src={srcPath("high-frequency-word/finish_play_again.png")}
              alt=""
              onLoad={addImgLoaded}
              onClick={() => dispatch(highFrequencyWordActions.playAgain())}
            />
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};

export default FinishBoard;
